module.exports = __webpack_public_path__ + "static/media/instagram.7e127b74.svg";